import React, {Component} from 'react'
import PropTypes from 'prop-types'
import wrappedIntlComponent from "./intl/WrappedIntlComponent"
import Header from './Header'
import Footer from "./Footer"
import blockerWrapper from "./blocker/BlockerComponent"


class WrapperFull extends Component {

    getChildContext() {
        return {
            formatMessage: this.props.formatMessage,
            showBlocker: this.props.showBlocker,
            hideBlocker: this.props.hideBlocker
        }
    }

    render() {
        let {children, renderButtonNav, renderFooterTop} = this.props

        return (
            <div className="wrapper wrapper--flex wrapper--default wrapper--fixed-header bg-bag">
                <Header renderButtonNav = {renderButtonNav} />
                <main>
                    {children}
                </main>
                <Footer renderFooterTop = {renderFooterTop} />
            </div>
        )
    }

    static childContextTypes = {
        formatMessage: PropTypes.any,
        showBlocker: PropTypes.any,
        hideBlocker: PropTypes.any
    }
}

export default wrappedIntlComponent(blockerWrapper(WrapperFull))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Wrapper-full.js